export enum AcceptanceAction {
  ACCEPT,
  REJECT,
  ABORT,
}

export namespace AcceptanceAction {
  let elements = [AcceptanceAction.ACCEPT, AcceptanceAction.REJECT, AcceptanceAction.ABORT];
  let alias = "com.bcdfx.api.servicerequest.trading.AcceptanceAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
